import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import axios from 'axios'
import { makeAutoObservable } from 'mobx'
import qs from 'qs'

import { envUtils } from '~/@common/utils/envUtils'

const BASE_URL = (() => {
  if (envUtils.isLive) {
    return `https://remote-storage.${domainProvider.TARGET_DOMAIN}`
  }
  if (envUtils.isStaging) {
    return `https://remote-storage-staging.${domainProvider.TARGET_DOMAIN}`
  }

  return `https://remote-storage-dev.${domainProvider.TARGET_DOMAIN}`
})()

export const remoteStorageAxios = axios.create({
  baseURL: BASE_URL,
  paramsSerializer: (params) => {
    return qs.stringify(params)
  },
})

type RemoteStorageItem = {
  curriculumKey: string | null
  isVisitedSelfLearning: boolean
  isCompletedSelfLearning: boolean
}

class RemoteStorageService implements RemoteStorageItem {
  private relationId: string | null = null
  curriculumKey: string | null = null
  isVisitedSelfLearning: boolean = false
  isCompletedSelfLearning: boolean = false
  isCompletedInitialStudentInfoSetting: boolean = false // B2G 학생 학교급, 학년 설정 완료 여부

  constructor() {
    makeAutoObservable(this)
  }

  get isReady() {
    return !!this.relationId
  }

  initRelationId = (relationId) => {
    if (!relationId) return

    this.relationId = relationId
  }

  get = async (...keys: string[]) => {
    if (!this.isReady) {
      return
    }

    const { data } = await remoteStorageAxios.get(`/storage/${this.relationId}`, {
      params: {
        keys: keys.join(','),
      },
    })

    for (const [k, v] of Object.entries(data)) {
      this._set(k, v)
    }

    // return data as Record<K, RemoteStorageItem[K]>
    return data
  }

  // ** 주의 **
  // write 후에 바로 최신 데이터 read가 필요한 경우에만 사용해야 함.
  // 정확한 최신 데이터를 보장할 수 있으나 조회 비용이 높음.(2배)
  //
  // consistentGet = async (...keys: string[]) => {
  //   if (!this.isReady) {
  //     return
  //   }

  //   const { data } = await remoteStorageAxios.get(
  //     `/storage/${this.relationId}?consistentRead=true`,
  //     {
  //       params: {
  //         keys: keys.join(','),
  //       },
  //     },
  //   )

  //   for (const [k, v] of Object.entries(data)) {
  //     this._set(k, v)
  //   }

  //   // return data as Record<K, RemoteStorageItem[K]>
  //   return data
  // }

  private _set = (k: string, v: any) => {
    this[k] = v
  }

  patch = async (k: string, v: any) => {
    if (!this.isReady) {
      return
    }

    remoteStorageAxios.patch(`/storage/${this.relationId}`, { [k]: v }).then(() => {
      this._set(k, v)
    })
  }
}

export const remoteStorageService = new RemoteStorageService()

globalThis.remoteStorageService = remoteStorageService
